import { LinearProgress, Stack } from '@mui/material';
import SplashLogo from '~/assets/splash/splash-logo.svg?react';

export default function AppLogoLoader() {
  return (
    <Stack>
      <LinearProgress
        sx={{
          '.MuiLinearProgress-barColorPrimary': {
            backgroundColor: 'black',
          },
          height: 8,
          borderRadius: 10,
          mb: 1,
          background: 'linear-gradient(90deg, #595151 0%, #A9AAAC 99.98%, #595151 99.99%, #F6F7FB 100%)',
        }}
      />
      <SplashLogo />
    </Stack>
  );
}
